export default __webpack_public_path__ + "images/ps-77489c5e7455703ed84f5548c3addbb3.svg";